'use client';

import { useJobMutations } from '@/modules/job/contracts';

import { Result } from '@packages/domain-driven';

export const useSaveJob = () => {
	const { saveJobMutation } = useJobMutations();

	const submit = async (jobId: string) => {
		try {
			await saveJobMutation.mutateAsync({ params: { jobId } });

			return Result.ok(true);
		}
		catch {
			return Result.fail('Unable to save job');
		}
	};

	return {
		submit,
		...saveJobMutation,
	};
};
